import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

import type { AggregatedPositionModel } from '@root/entities/position/atoms'

type Props = {
  position: AggregatedPositionModel
  onEditClick?: () => void
  onCloseClick?: () => void
}

export const TradePositionDetailsAction: React.FC<Props> = ({
  position: _,
  onEditClick,
  onCloseClick,
}) => {
  const { t } = useTranslation()

  // TODO: Check after redesigns
  const canEdit = false

  return (
    <Root>
      <ButtonEdit
        size="m"
        radius="rounded"
        variant="secondary"
        type="button"
        onClick={onEditClick}
        disabled={!canEdit}
      >
        {t('trade.button.edit')}
      </ButtonEdit>
      <ButtonClose
        color="acid"
        size="m"
        radius="rounded"
        type="button"
        variant="glass"
        onClick={onCloseClick}
        disabled={!canEdit}
      >
        {t('position.close-position')}
      </ButtonClose>
    </Root>
  )
}

const Root = styled.nav`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  padding-inline: 12px;
  padding-block: 0 var(--safe-bottom);

  background: var(--dark-grey-60, rgba(25, 25, 25, 0.6));
`

const ButtonEdit = styled(Button)`
  text-transform: uppercase;
  font-weight: 500;
`

const ButtonClose = styled(Button)`
  text-transform: uppercase;
`
